/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
const r = (t, e) => {
  Object.keys(e).forEach((o) => {
    t.append(o, e[o]);
  });
}, p = (t, e, o) => {
  const n = new FormData();
  return r(n, o), t.forEach((a) => {
    const s = a.getRawFile ? a.getRawFile() : "";
    s ? n.append(e, s, a.name) : n.append(e, s);
  }), n;
}, c = (t, e, o) => {
  const n = new FormData();
  return r(n, o), t.forEach((a) => {
    n.append(e, a);
  }), n;
}, l = (t, e) => ({
  headers: t,
  responseType: e.responseType,
  withCredentials: e.withCredentials
}), u = (t) => {
  const e = {};
  return Object.keys(t).forEach((o) => {
    e[o] = t[o];
  }), e;
}, d = (t) => {
  const { data: e, config: o, ...n } = t;
  return {
    response: e,
    ...n
  };
}, i = {
  populateClientFormData: r,
  populateUploadFormData: p,
  populateRemoveFormData: c,
  populateRequestOptions: l,
  cloneRequestHeaders: u,
  convertAxiosResponse: d
};
export {
  i as default
};
